import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';

import {
    addOpacityToHexColor,
} from '../../../utils/courtSchedular';
import { getLabelByTypeId } from '../../../utils/types';

import styles from './dayPlanner.scss';
import { primaryViews } from '../../../utils/dayPlanner';

const Match = (props) => {
    const {
        match,
        primaryView,
        isScheduled = false,
        'data-testid': dataTestId,
    } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);

    const {
        division: {
            tournament: {
                scoringTypes,
            },
        },
    } = coreUI.types.tms;

    const customStyles = {
        border: `2px solid ${addOpacityToHexColor(match.drawColor, 0.4)}`,
        backgroundColor: addOpacityToHexColor(match.drawColor, 0.1),
    };

    const matchStatusStyles = {
        backgroundColor: match.drawColor,
    };

    const scoringType = getLabelByTypeId(scoringTypes, match.tmsTournamentScoringTypeId);

    return (
        <div
            className={`${styles.draggableMatch} mt4 mb4 ${match.addDisableOverlay ? styles.disable : ''}`}
            style={customStyles}
            data-testid={dataTestId}
        >
            <div className={styles.statusLayout}>
                <div className={styles.matchStatus} style={matchStatusStyles} data-testid={dataTestId && `${dataTestId}.match-number`}>
                    {match.matchNumber}
                </div>
            </div>
            <div className={`${styles.matchData}`}>
                <div className={styles.selectContainer}>
                    <div className="flex-1" />
                </div>
                {primaryView === primaryViews.DraftDraws && (
                    <div className={`${styles.player}`} data-testid={dataTestId && `${dataTestId}.matchup`}>
                        {match.matchup}
                    </div>
                )}
                {isScheduled && (
                    <div className={`${styles.details}`} data-testid={dataTestId && `${dataTestId}.draw-name`}>
                        {match.drawName}
                    </div>
                )}
                <div className={`${styles.details}`} data-testid={dataTestId && `${dataTestId}.round-name`}>
                    {`${match.groupName}, ${match.roundName}`}
                </div>
                {scoringType && (
                    <div className={`${styles.details}`} data-testid={dataTestId && `${dataTestId}.scoring-type`}>
                        {scoringType}
                    </div>
                )}
            </div>
            {isScheduled && match.addDisableOverlay && (
                <div className={styles.disableOverlay} />
            )}
        </div>
    );
};

Match.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
    primaryView: PropTypes.string.isRequired,
    isScheduled: PropTypes.bool,
    'data-testid': PropTypes.string,
};

Match.defaultProps = {
    isScheduled: false,
    'data-testid': undefined,
};

export default Match;
